import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";
import { backendGet, backendPost } from "@accredo/fe-shared/services/dataService.js";
import { useSnackbar } from "notistack";
import BookingExports from "pages/admin/bookings/components/BookingExports.jsx";


const AssignExportModal = ({ open, onClose, payment, onActionComplete }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [exports, setExports] = useState([]);
  const [selectedExport, setSelectedExport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchExports = async () => {
      if (!open || !payment) return;
      setError(null);
      setLoading(true);
      setSelectedExport(null);

      await backendGet("data/bookingexports", {
        label: "Booking Exports",
        setIsLoading: setLoading,
        enqueueSnackbar,
        options: {
          params: {
            "status[]": "created",
            include: ["created_by"],
          },
        },
        setResult: (data) => {
          setExports(data.data);
          const matchingExport = data.data.find(
            (exp) => parseFloat(exp.summe) === parseFloat(payment.amount)
          );
          if (matchingExport) {
            setSelectedExport(matchingExport.id);
            enqueueSnackbar(
              `Passender Export ${matchingExport.export_identifier} vorausgewählt.`,
              { variant: "info" }
            );
          }
        },
        onError: () => setError("Fehler beim Laden der Exporte."),
      });
    };

    fetchExports();
  }, [open, payment, enqueueSnackbar]);

  const handleAssign = async () => {
    if (!selectedExport) {
      enqueueSnackbar("Bitte einen Export auswählen.", { variant: "warning" });
      return;
    }

    await backendPost("data/payments/assign-to-export", {
      toSend: {
        payment_ids: [payment.id],
        booking_export_id: selectedExport,
      },
      label: "Zahlung zuordnen",
      setIsLoading: setIsSubmitting,
      enqueueSnackbar,
      setResult: () => {
        onActionComplete();
        onClose();
      },
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Zahlung einem Export zuordnen</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <CircularProgress />
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : exports.length > 0 ? (
          <>

            <BookingExports
              initialBookingExports={exports}
              showPagination={false}
              selectedExport={selectedExport}
              onExportSelect={(be) => setSelectedExport(be.id)}
              showActions={false}
            />
          </>

        ) : (
          <Alert severity="info">
            Keine offenen Exporte zum Zuordnen gefunden.
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        {isSubmitting && <CircularProgress size={24} />}
        <Button onClick={onClose} disabled={isSubmitting} color="inherit">
          Abbrechen
        </Button>
        <Button
          onClick={handleAssign}
          disabled={
            loading || isSubmitting || !selectedExport || exports.length === 0
          }
          variant="contained"
        >
          Zuordnen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignExportModal;
